import { Link } from "react-router-dom";
import arrow from '../pics/arrow.svg'
import back from '../pics/back.svg'
import  './HeaderDropdownItem.css'

const HeaderDropdownItem = (props) => {
  
  return (
    <div onClick={() => props.onClick(props.index)}>
        <Link to={ props.to } onClick={() => { window.scroll(0, 0);}}  style={{textDecoration: 'none'}}>
          <div className="header-item-line">
            <h4 className={`header-dropdown-text${props.selectedItem === props.index ? '-selected' : ''}`}>{ props.text }</h4>
            {props.selectedItem === props.index && <img src={back} className="header-selected-arrow"/>}
          </div>
        </Link>
    </div>
  );
};

export default HeaderDropdownItem;
